import { cn } from "@/lib/utils";

interface FeltTableProps {
  children: React.ReactNode;
  className?: string;
}

export default function FeltTable({ children, className }: FeltTableProps) {
  return (
    <div
      className={cn(
        "bg-[var(--win2k-felt-green)] min-h-0 flex-1",
        "bg-[radial-gradient(ellipse_at_center,_var(--win2k-felt-green)_0%,_var(--win2k-felt-dark)_100%)]",
        "p-2 md:p-4",
        className
      )}
    >
      {children}
    </div>
  );
}
